import React, { createContext, useContext, useState } from "react";

const DashTabContext = createContext();

export function DashTabProvider({ children }) {
  const [activeTab, setActiveTab] = useState(0);
  return (
    <DashTabContext.Provider value={{ activeTab, setActiveTab }}>
      {children}
    </DashTabContext.Provider>
  );
}

export function useDashTab() {
  return useContext(DashTabContext);
}
